import { useContext } from 'react'
import FormInputHint from './FormInputHint'
import { Form, Icon, Container, Text, ValidationFn } from 'roadie-ui'
import { useLocalization, type TranslationKey } from 'localization'

const { matchesRegex, minLength, maxLength } = Form.validations

const requirements: { labelKey: TranslationKey; validate: ValidationFn }[] = [
  {
    labelKey: 'dweb_password_requirement_lowercase',
    validate: matchesRegex(/[a-z]/),
  },
  {
    labelKey: 'dweb_password_requirement_uppercase',
    validate: matchesRegex(/[A-Z]/),
  },
  {
    labelKey: 'dweb_password_requirement_number',
    validate: matchesRegex(/[0-9]/),
  },
  {
    labelKey: 'dweb_password_requirement_special_character',
    validate: matchesRegex(/[-+_!@#$%^&*., ?]/),
  },
  {
    labelKey: 'dweb_password_requirement_min_8_characters_lowercase',
    validate: minLength(8),
  },
  {
    labelKey: 'dweb_password_requirement_max_50_characters_lowercase',
    validate: maxLength(50),
  },
]

function isValid(text: string, fn: ValidationFn) {
  try {
    fn(text)
  } catch (e) {
    return false
  }
  return true
}

const PasswordRequirements = () => {
  const { t } = useLocalization()
  const { raw } = useContext(Form.InputContext)

  return (
    <FormInputHint inline>
      <Container.Grid $gridTemplateColumns="50% 50%" $gridGap="1rem" $backgroundColor="neutral-white" $padding="2rem">
        {requirements.map((req) => (
          <Container.Grid key={req.labelKey} $gridTemplateColumns="1.5rem 1fr" $gridGap="1rem">
            <Icon.CheckmarkCircle
              $width="1.5rem"
              $color={raw && isValid(raw, req.validate) ? 'success-base' : 'neutral-light'}
            />
            <Text.Caption>{t(req.labelKey)}</Text.Caption>
          </Container.Grid>
        ))}
      </Container.Grid>
    </FormInputHint>
  )
}

export default PasswordRequirements
